export const HotelRoutes = {
  LIST: "/hotels",
  DETAIL: "/hotels/:id",
} as const;
